import React from 'react';
import {officeMember} from "../../../models/officeMember";
import DateService from "../../../service/DateService";

type OfficeMemberListProps = {
  officeMember: officeMember[]
}

export const OfficeMemberList = ({officeMember}: OfficeMemberListProps) => {
  return (
    <table className="table table-responsive table-hover border">
      <thead>
      <tr className="table-primary">
        <th>Poste</th>
        <th>Nom</th>
        <th>Prénom</th>
        <th className="text-center w150px">Modification</th>
      </tr>
      </thead>
      <tbody>
      {officeMember.map((om: officeMember) => (
        <tr>
          <td>{om.label}</td>
          <td>{om.member?.name ?? '~'}</td>
          <td>{om.member?.firstname ?? '~'}</td>
          <td className="text-center">
            {DateService
              .toLocaleString(om.updatedAt ?? om.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
            }
          </td>
        </tr>
      ))}
      </tbody>
    </table>
  )
}
